"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License
Object.defineProperty(exports, "__esModule", { value: true });
class TelemetryConstants {
    constructor() {
        this.channelIdProperty = 'channelId';
        this.conversationIdProperty = 'conversationId';
        this.conversationNameProperty = 'conversationName';
        this.dialogIdProperty = 'dialogId';
        this.fromIdProperty = 'fromId';
        this.fromNameProperty = 'fromName';
        this.localeProperty = 'locale';
        this.recipientIdProperty = 'recipientId';
        this.recipientNameProperty = 'recipientName';
        this.replyActivityIdProperty = 'replyActivityId';
        this.textProperty = 'text';
        this.speakProperty = 'speak';
        this.userIdProperty = 'userId';
    }
}
exports.TelemetryConstants = TelemetryConstants;
//# sourceMappingURL=telemetryConstants.js.map